import { capitalize } from 'util/strings'

export function isPlanLimitsExceeded(plan, usage) {
  const productFeatures = plan.features
  const featureLookup = Object.keys(productFeatures)
  const productUsage = usage
  return Object.keys(productUsage).some(key => {
    const usageValue = productUsage[key]
    // Eg custom_profile, rules
    if (
      featureLookup.includes(key) &&
      typeof usageValue === 'boolean' &&
      usageValue &&
      !productFeatures[key]
    ) {
      return true
    }

    // Eg teams
    if (
      featureLookup.includes(key) &&
      typeof usageValue === 'number' &&
      usageValue > 0 &&
      !productFeatures[key]
    ) {
      return true
    }

    // Eg max_channels, max_integrations, max_kbs
    const featureKey = `max${capitalize(key)}`
    if (
      featureLookup.includes(featureKey) &&
      typeof usageValue === 'number' &&
      productFeatures[featureKey] !== 'unlimited' &&
      usageValue > productFeatures[featureKey]
    ) {
      return true
    }

    return false
  })
}

export function isAllowedAccessToFeature(plan, feature) {
  if (!plan || !plan.features || !feature) return true
  return !!plan.features[feature]
}

export function isPlanSmaller(currentPlan, newPlan) {
  if (currentPlan.version !== newPlan.version) return false
  return currentPlan.monthlyPrice >= newPlan.monthlyPrice
}
